"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposedPromise = exports.ExposedPromiseStatus = void 0;
var ExposedPromiseStatus;
(function (ExposedPromiseStatus) {
    ExposedPromiseStatus["INITIAL"] = "initial";
    ExposedPromiseStatus["PENDING"] = "pending";
    ExposedPromiseStatus["RESOLVED"] = "resolved";
    ExposedPromiseStatus["REJECTED"] = "rejected";
})(ExposedPromiseStatus = exports.ExposedPromiseStatus || (exports.ExposedPromiseStatus = {}));
/* eslint-disable prefer-arrow/prefer-arrow-functions */
function notInitialized() {
    throw new Error('ExposedPromise not initialized yet.');
}
class ExposedPromise {
    constructor() {
        this._resolve = notInitialized;
        this._reject = notInitialized;
        this._status = ExposedPromiseStatus.INITIAL;
        this._promise = new Promise((innerResolve, innerReject) => {
            this._resolve = async (value) => {
                this._status = ExposedPromiseStatus.PENDING;
                try {
                    this._promiseResult = await value;
                }
                catch (innerReason) {
                    return innerReject(innerReason);
                }
                this._status = ExposedPromiseStatus.RESOLVED;
                return innerResolve(value);
            };
            this._reject = async (reason) => {
                this._status = ExposedPromiseStatus.REJECTED;
                this._promiseError = await reason;
                return innerReject(reason);
            };
        });
    }
    get promise() {
        return this._promise;
    }
    get resolve() {
        return this._resolve;
    }
    get reject() {
        return this._reject;
    }
    get status() {
        return this._status;
    }
    get promiseResult() {
        return this._promiseResult;
    }
    get promiseError() {
        return this._promiseError;
    }
    isPending() {
        return this.status === ExposedPromiseStatus.PENDING;
    }
    isResolved() {
        return this.status === ExposedPromiseStatus.RESOLVED;
    }
    isRejected() {
        return this.status === ExposedPromiseStatus.REJECTED;
    }
    isSettled() {
        return this.isPending() || this.isRejected();
    }
}
exports.ExposedPromise = ExposedPromise;
/* eslint-enable prefer-arrow/prefer-arrow-functions */
//# sourceMappingURL=exposed-promise.js.map